const filterProducts = (tempProducts, filter) => {
  const results = tempProducts.filter((x) => {
    let optionValues = []
    const colorsForProduct = x.tags.map((tag) =>
      tag.value.replace('color: ', '')
    )

    x.options.forEach((option) => {
      option.values.forEach((y) => {
        optionValues = [...optionValues, y.value]
      })
    })

    if (filter.size && !filter.color) {
      return optionValues.includes(filter.size)
    } else if (!filter.size && filter.color) {
      return colorsForProduct.includes(filter.color)
    } else if (filter.size && filter.color) {
      return (
        colorsForProduct.includes(filter.color) &&
        optionValues.includes(filter.size)
      )
    }
  })

  return results
}

export default filterProducts
